/* eslint-disable no-param-reassign */
// Application settings
export const setApplicationSettingsImplementation = (state, action) => {
  const { configuration } = state;

  const applicationSettings = action.payload;

  configuration.configData.applicationSettings = applicationSettings;

  state.configuration = configuration;
};

export const setApplicationSettingsChangedImplementation = (state, action) => {
  state.applicationSettingsChanged = action.payload;
};

export const saveApplicationDataDependenciesImplementation = (state, action) => {
  const { axisId, dependencies, appDataPayload } = action.payload;
  const { configuration } = state;

  // store dependencies in configuration.configData.axes[].axisState.dependencies
  const axis = configuration?.configData?.axes?.find((a) => a.id === axisId);

  if (!axis) {
    return;
  }

  axis.axisState.dependencies = dependencies;

  axis.axisState.savedApplicationDataPayload = appDataPayload;

  state.configuration = configuration;
};

// Motor
export const setSavedMotorDependenciesPayloadImplementation = (state, action) => {
  state.savedDependenciesPayloads.motor = action.payload;
};

// Descriptions
export const setProductsDescriptionsImplementation = (state, action) => {
  const { configuration } = state;
  const { locale } = state;
  const productsDescriptions = action.payload;

  // eslint-disable-next-line no-param-reassign
  configuration.configData.axes.forEach((axis) => {
    const { motor } = axis.bundle.bundleData;
    const { drive } = axis.bundle.bundleData;
    const { gearbox } = axis.bundle.bundleData;
    const { adaptationKit } = axis.bundle.bundleData;

    const motorDescription = productsDescriptions.find((p) => p.catalogue_product.id === motor.commercialReference);
    const driveDescription = productsDescriptions.find((p) => p.catalogue_product.id === drive.commercialReference);
    const gearboxDescription = productsDescriptions.find((p) => p.catalogue_product.id === gearbox.commercialReference);
    const adaptationKitDescription = productsDescriptions.find(
      (p) => p.catalogue_product.id === adaptationKit.commercialReference
    );

    if (motorDescription) {
      motor.description = motorDescription.catalogue_product.long_desc.translation[locale];
    }
    if (driveDescription) {
      drive.description = driveDescription.catalogue_product.long_desc.translation[locale];
    }
    if (gearboxDescription) {
      gearbox.description = gearboxDescription.catalogue_product.long_desc.translation[locale];
    }
    if (adaptationKitDescription) {
      adaptationKit.description = adaptationKitDescription.catalogue_product.long_desc.translation[locale];
    }
  });

  // eslint-disable-next-line no-param-reassign
  state.configuration = configuration;
};
